/**
 * Naming for the row a copy button opens.
 *
 * The copy dialog opens pre-filled from the original, so the name is the only
 * thing telling the two apart at a glance — it is marked before the user sees
 * it rather than after they save. Copying a copy simply marks it again
 * ("Corp 1 COPY COPY"): predictable beats clever, and the dialog focuses the
 * field for renaming anyway.
 */
export const COPY_SUFFIX = 'COPY';

/** Every project item (cabinet, panel, countertop) caps its name at 200. */
export const ITEM_NAME_MAX_LENGTH = 200;

export function copyName(name: string, maxLength = ITEM_NAME_MAX_LENGTH): string {
  const base = name.trim();
  const suffixed = base ? `${base} ${COPY_SUFFIX}` : COPY_SUFFIX;
  if (suffixed.length <= maxLength) return suffixed;
  // The suffix is the part that says what this row is, so the original name
  // loses its tail instead — the focused field is right there to fix it.
  const room = maxLength - COPY_SUFFIX.length - 1;
  if (room <= 0) return COPY_SUFFIX.slice(0, maxLength);
  return `${base.slice(0, room).trimEnd()} ${COPY_SUFFIX}`;
}
